// extracted by mini-css-extract-plugin
export default {"modalWareHouse":"create-warehouse-modal-form_modalWareHouse__C8Jis","coordinate_example":"create-warehouse-modal-form_coordinate_example__KfdUr"};